import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=bbb690f8"
import script from "./ModalAlert.vue?vue&type=script&lang=js"
export * from "./ModalAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports